import InputBox, { InputBoxProps } from './InputBox';

export type { InputBoxProps };
export default InputBox;
